import EligibilityChecker from './aca_reporting/EligibilityChecker'

interface ACAReportingPageProps {
  plan_year: number
}

export default function ACAReportingPage ({
  plan_year: planYear
}: ACAReportingPageProps) {
  return <EligibilityChecker planYear={planYear} />
}
